import { makeStyles } from '@material-ui/core/styles';
export default makeStyles((theme) => ({
    marginLeftAuto: {
        marginLeft: "auto",
      },
      modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      connectModalWalletIcon:{
        height:"45px",
        width:"45px"
      },
      paper: {
        backgroundColor: theme.palette.background.paper,
        //   boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        borderRadius: "1.5625rem",
        outline: "none",
        position: "relative",
        width: "450px",
        marginLeft: "10px",
        marginRight: "10px",
        boxShadow: "4px 4px 40px rgba(0, 0, 0, 0.6)",
        "@media (max-width:550px)": {
          padding: "12px 16px",
          fontSize: "14px",
        },
      },
      connectWallet: {
        display: "flex",
      },
      closeIcon: {
        marginRight: "auto",
        right: "26px",
        top: "26px",
        position: "absolute",
        cursor:"pointer",
        padding: "5px",
        transform: "scale(1.2)",
            borderRadius:"100px",
        "&:hover": {
        backgroundColor: "#ebe7e7",
      },
      },
      connectWalletText: {
        fontSize: "1.3625rem",
        fontWeight: "600",
        fontFamily:"Inter",
        padding: "15px 0px",
        "@media (max-width:550px)": {
          padding: " 14px 0px",
          fontSize: "1.0625rem",
        },
      },
      walletList: {
        // display:"flex",
        // padding:"10px 15px",
      },
      walletItem: {
        height:"45px",
        background: "#E7EEFF",
        cursor: "pointer",
        borderRadius: "12px",
        padding: "10px 15px",
        margin: "10px 0px",
        display: "flex",
        fontSize: "1.125rem",
        fontFamily: "Mulish",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "18px",
        alignItems:"center",
        color: "#282828",
    
        flex: "none",
        order: "0",
        flexGrow: "0",
        "&:hover": {
          backgroundColor: "#dce2f3",
        },
       
      },selectedWallet:{
        background: "#FFDF00",
        "&:hover":{
          background: "#f7d905",
        }
      },
      WalletIcon: {
        marginLeft: "auto",
        "& img":{
            display: "block",
        }
      },
      backDrop: {
        backdropFilter: "blur(10px)",
        backgroundColor: "rgba(150, 150, 150, 0.4)",
      },
}));